<template>
  <ChartBlock class="chart-container">
    <div ref="explorerLineChart" class="explorer-card-content">
      <div class="title-content">
        <ExplorerCardTitle v-if="dataKey.snake" :title="title"/>
        <slot name="metric-dropdown"></slot>
      </div>
      <div v-if="loading" class="loading-content">
        <Loader
          :loading="loading"
        />
      </div>
      <div v-else-if="showChart" class="data-content">
        <ExplorerLineChart
          :dataKey="dataKey"
          :data="data"
          :chartWidth="chartWidth"
          :chartHeight="chartHeight"
          :isInPercentages="isInPercentages"
        />
      </div>
      <div v-else class="hint-text">
        {{message}}
      </div>
    </div>
  </ChartBlock>
</template>

<script>
import ChartBlock from '../../Common/Charting/Shared/ChartBlock.vue';
import Loader from '../../Common/Charting/Shared/Loader.vue';
import ExplorerLineChart from '../ExplorerChart/ExplorerLineChart.vue';
import ExplorerCardTitle from './ExplorerCardTitle.vue';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    dataKey: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartWidth: 1200,
      chartHeight: 284,
      horizontalPadding: 32,
    };
  },
  components: {
    ChartBlock,
    Loader,
    ExplorerLineChart,
    ExplorerCardTitle,
  },
  methods: {
    handleResize() {
      const chart = this.$refs.explorerLineChart;

      this.chartWidth = chart.clientWidth - this.horizontalPadding;
    },
  },
  computed: {
    title() {
      return this.dataKey.key + ' Time Series';
    },
    showChart() {
      return this.message === '';
    },
    isInPercentages() {
      return !!(this.dataKey.snake && this.dataKey.snake.includes('rate'));
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
};
</script>

<style scoped>
.chart-block {
  margin: 0px;
  margin-top: 16px;
  width: 100%;
  height: 362px;
}

.explorer-card-content {
  padding: 16px;
  height: 100%;
}

.title-content {
  display: flex;
  height: 44px;
  justify-content: space-between;
}

.hint-text {
  font-size: 18px;
}

.data-content {
  position: relative;
}

.loading-content {
  height: 60%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
